import React, { useState } from "react";
import styles from "./AudioScrollableCard.module.css";
import { Link, useNavigate } from "react-router-dom";

import Rabbit from "rabbit-node/lib/rabbit";

const AudioScrollableCard = ({
  data,
  title,
  category_id = null,
  category_type = null,
}) => {
  const navigate = useNavigate();

  const handleClick = (item) => {
    navigate(`/audio/book-detail/${item.audio_uniq_idx}`);
  };

  return (
    <div className={`w-full`}>
      <div className="my-4">
        <h1 className={`${styles.title} text-sm text-amber-300`}>
          {Rabbit.zg2uni(title)}
        </h1>
        {/* <span className="float-right text-yellow-400">See All</span> */}
        {category_id && category_type && (
          <Link
            to={`/music/see_all/${category_id}/${category_type}`}
            className="float-right text-yellow-400"
          >
            See All
          </Link>
        )}
      </div>
      <div className={`${styles.imageContainer} my-4 mx-0`}>

          {data.map((item, index) => (
            <div
              className={`${index === data.length - 1 ? "" : "mr-4"} ${styles.scrollableImage}`}
              key={index}
              onClick={() => handleClick(item)}
            >
              <div className="relative">
                <img
                  src={item.thumb}
                  alt={`Image ${index + 1}`}
                  className={`${styles.image} rounded-lg`}
                />
                {item.prize === "Free" && (
                  <div className="absolute top-0 left-0 rounded-tl-lg rounded-lg text-yellow-600 text-center text-xs overflow-hidden py-1 px-2 rounded-r-full bg-black">
                    အခမဲ့
                  </div>
                )}
              </div>
              <span className="block text-sm mt-2 truncate pb-1">
                {item.name_unicode}
              </span>
              <span className="block text-xs mt-2 truncate pb-1">
                {item.author_unicode}
              </span>
            </div>
          ))}


        {/* {data.result.map((item, index) => (
          <div
            className={`${index === data.length - 1 ? "" : "mr-4"} ${
              styles.scrollableImage
            }`}
            key={index}
            onClick={() => handleClick(item)}
          >
            <div className="relative">
              <img
                src={item.thumb}
                key={index}
                alt={`Image ${index + 1}`}
                className={`${styles.image} rounded-lg`}
              />
              {item.prize == "Free" && (
                <div className="absolute top-0 left-0 rounded-tl-lg rounded-lg text-yellow-600 text-center text-xs overflow-hidden py-1 px-2 rounded-r-full bg-black">
                  အခမဲ့
                </div>
              )}
            </div>
            <span className="block text-sm mt-2 truncate pb-1">
              {item.name_unicode}
            </span>
            <span className="block text-xs mt-2 truncate pb-1">
              {item.author_unicode}
            </span>
          </div>
        ))} */}
      </div>
    </div>
  );
};

export default AudioScrollableCard;
